import fontHeadingURL from '../theme/fonts/Campton-SemiBold.otf';
import {normalize, setupPage} from 'csstips';
import {injectGlobal} from '../theme/global';

export const setupGlobalCSS = (root: string = '#root') => {
  normalize();
  setupPage(root);
  injectGlobal({ fontHeadingURL });
};